import styled from 'styled-components'
import icoArrow from '../../assets/Icons/arrow_down.svg'

export const StyledSelect = styled.select`
  appearance: none;
  box-sizing: border-box;
  outline: none;
  background: transparent url(${icoArrow}) no-repeat calc(100% - 16px) center;
  margin: 0;
  width: ${({ width }) => (width ? `${width}px` : '100%')};
  border: 1px solid var(--text-light);
  border-radius: 10px;
  padding: 16px;
  font-size: var(--font-size-sm);
  color: var(--text-tertiary);
`
